import Vapi from 'vuex-rest-api'

import http from 'src/http/index'
import { beforeRequestReset, createSuccess, deleteSuccess, updateSuccess } from 'components/utils/storeUtils'

const initialState = () => ({
  assets: null,
  asset: {},
  complexen: null,
  complex: {},
  ruimten: null,
  ruimte: {},
  asset_ruimtes: null,
  inventarisatie_ruimtes: null,
  plattegronden: null,
  asset_plattegronden: null,
  plattegrond: {},
  asset_fotos: null,
  asset_foto: null,
  asset_templates: null,
  asset_template: {},
  asset_template_ruimten: null,
  asset_template_ruimte: {}
})

const assetDepKeys = ['ruimte', 'plattegrond', 'asset_ruimtes', 'inventarisatie_ruimtes', 'asset_plattegronden', 'asset_fotos', 'asset_foto']

const templateDepKeys = ['asset_template_ruimten', 'asset_template_ruimte']

const vastgoed = new Vapi({
  axios: http.axios,
  baseURL: process.env.API_URL + '/vastgoed',
  queryParams: true,
  state: initialState()
})
  .get({
    action: 'GET_ASSETS',
    property: 'assets',
    path: '/asset?include=inventarisatie_asset'
  })
  .get({
    action: 'GET_ASSET',
    property: 'asset',
    queryParams: true,
    path: ({ id }) => `/asset/${id}`,
    beforeRequest: beforeRequestReset('asset', assetDepKeys, initialState())
  })
  .post({
    action: 'CREATE_ASSET',
    property: 'asset',
    path: '/asset',
    onSuccess: createSuccess('asset', 'assets')
  })
  .post({
    action: 'UPDATE_ASSET',
    property: 'asset',
    path: ({ id }) => `/asset/${id}`,
    onSuccess: updateSuccess('asset', 'assets')
  })
  .delete({
    action: 'DELETE_ASSET',
    property: 'asset',
    queryParams: true,
    path: ({ id }) => `/asset/${id}`,
    onSuccess: deleteSuccess('asset')
  })
  .get({
    action: 'GET_COMPLEXEN',
    property: 'complexen',
    queryParams: true,
    path: '/complex'
  })
  .get({
    action: 'GET_COMPLEX',
    property: 'complex',
    queryParams: true,
    path: ({ id }) => `/complex/${id}`
  })
  .post({
    action: 'CREATE_COMPLEX',
    property: 'complex',
    path: '/complex',
    onSuccess: createSuccess('complex', 'complexen')
  })
  .post({
    action: 'UPDATE_COMPLEX',
    property: 'complex',
    path: ({ id }) => `/complex/${id}`,
    onSuccess: updateSuccess('complex', 'complexen')
  })
  .delete({
    action: 'DELETE_COMPLEX',
    property: 'complex',
    queryParams: true,
    path: ({ id }) => `/complex/${id}`,
    onSuccess: deleteSuccess('complex')
  })
  .get({
    action: 'GET_INVENTARISATIE_RUIMTES_FROM_ASSET',
    queryParams: true,
    property: 'inventarisatie_ruimtes',
    path: ({ assetId }) => `/asset/${assetId}/inventarisatie_asset/inventarisatie_ruimtes`
  })
  .get({
    action: 'GET_RUIMTEN',
    queryParams: true,
    property: 'ruimten',
    path: '/ruimte'
  })
  .get({
    action: 'GET_RUIMTEN_FROM_ASSET',
    queryParams: true,
    property: 'asset_ruimtes',
    path: ({ assetId }) => `/asset/${assetId}/ruimten`
  })
  .get({
    action: 'GET_RUIMTE',
    property: 'ruimte',
    queryParams: true,
    path: ({ id }) => `/ruimte/${id}`
  })
  .post({
    action: 'CREATE_RUIMTE',
    property: 'ruimte',
    path: '/ruimte',
    onSuccess: createSuccess('ruimte', 'ruimten')
  })
  .post({
    action: 'UPDATE_RUIMTE',
    property: 'ruimte',
    path: ({ id }) => `/ruimte/${id}`,
    onSuccess: updateSuccess('ruimte', 'ruimten')
  })
  .delete({
    action: 'DELETE_RUIMTE',
    property: 'ruimte',
    requestConfig: {
      headers: {
        'X-Strmln-Forced-Delete': true
      }
    },
    queryParams: true,
    path: ({ id }) => `/ruimte/${id}`,
    onSuccess: deleteSuccess('ruimte')
  })
  .get({
    action: 'GET_PLATTEGRONDEN_FROM_ASSET',
    queryParams: true,
    property: 'asset_plattegronden',
    path: ({ assetId }) => `/asset/${assetId}/plattegronden`
  })
  .get({
    action: 'GET_PLATTEGROND',
    property: 'plattegrond',
    queryParams: true,
    path: ({ id }) => `/plattegrond/${id}`
  })
  .post({
    action: 'CREATE_PLATTEGROND',
    property: 'plattegrond',
    path: '/plattegrond',
    onSuccess: createSuccess('plattegrond', 'plattegronden')
  })
  .post({
    action: 'UPDATE_PLATTEGROND',
    property: 'plattegrond',
    path: ({ id }) => `/plattegrond/${id}`,
    onSuccess: updateSuccess('plattegrond', 'plattegronden')
  })
  .delete({
    action: 'DELETE_PLATTEGROND',
    property: 'plattegrond',
    queryParams: true,
    path: ({ id }) => `/plattegrond/${id}`,
    onSuccess: deleteSuccess('plattegrond')
  })
  .get({
    action: 'GET_FOTOS_FROM_ASSET',
    queryParams: true,
    property: 'asset_fotos',
    path: ({ assetId }) => `/asset/${assetId}/asset_fotos`
  })
  .get({
    action: 'GET_ASSET_FOTO',
    property: 'asset_foto',
    queryParams: true,
    path: ({ id }) => `/asset_foto/${id}`
  })
  .post({
    action: 'CREATE_ASSET_FOTO',
    property: 'asset_foto',
    path: '/asset_foto',
    onSuccess: createSuccess('asset_foto', 'asset_fotos')
  })
  .post({
    action: 'UPDATE_ASSET_FOTO',
    property: 'asset_foto',
    path: ({ id }) => `/asset_foto/${id}`,
    onSuccess: updateSuccess('asset_foto', 'asset_fotos')
  })
  .delete({
    action: 'DELETE_ASSET_FOTO',
    property: 'asset_foto',
    queryParams: true,
    path: ({ id }) => `/asset_foto/${id}`,
    onSuccess: deleteSuccess('asset_foto')
  })
  .get({
    action: 'GET_ASSET_TEMPLATES',
    property: 'asset_templates',
    queryParams: true,
    path: '/asset_template'
  })
  .get({
    action: 'GET_ASSET_TEMPLATE',
    property: 'asset_template',
    queryParams: true,
    path: ({ id }) => `/asset_template/${id}`,
    beforeRequest: beforeRequestReset('asset_template', templateDepKeys, initialState())
  })
  .post({
    action: 'CREATE_ASSET_TEMPLATE',
    property: 'asset_template',
    path: '/asset_template',
    queryParams: true,
    onSuccess: createSuccess('asset_template', 'asset_templates')
  })
  .post({
    action: 'UPDATE_ASSET_TEMPLATE',
    property: 'asset_template',
    queryParams: true,
    path: ({ id }) => `/asset_template/${id}`,
    onSuccess: updateSuccess('asset_template', 'asset_templates')
  })
  .delete({
    action: 'DELETE_ASSET_TEMPLATE',
    property: 'asset_template',
    queryParams: true,
    path: ({ id }) => `/asset_template/${id}`,
    beforeRequest: beforeRequestReset('asset_template', templateDepKeys, initialState()),
    onSuccess: deleteSuccess('asset_template')
  })
  .get({
    action: 'GET_ASSET_RUIMTES_FROM_TEMPLATE',
    queryParams: true,
    property: 'asset_template_ruimten',
    path: ({ templateId }) => `/asset_template/${templateId}/asset_template_ruimten`
  })
  .get({
    action: 'GET_ASSET_TEMPLATE_RUIMTE',
    property: 'asset_template_ruimte',
    queryParams: true,
    path: ({ id }) => `/asset_template_ruimte/${id}`
  })
  .post({
    action: 'CREATE_ASSET_TEMPLATE_RUIMTE',
    property: 'asset_template_ruimte',
    path: '/asset_template_ruimte',
    queryParams: true,
    onSuccess: createSuccess('asset_template_ruimte', 'asset_template_ruimten')
  })
  .post({
    action: 'UPDATE_ASSET_TEMPLATE_RUIMTE',
    property: 'asset_template_ruimte',
    queryParams: true,
    path: ({ id }) => `/asset_template_ruimte/${id}`,
    onSuccess: updateSuccess('asset_template_ruimte', 'asset_template_ruimten')
  })
  .delete({
    action: 'DELETE_ASSET_TEMPLATE_RUIMTE',
    property: 'asset_template_ruimte',
    queryParams: true,
    path: ({ id }) => `/asset_template_ruimte/${id}`,
    onSuccess: deleteSuccess('asset_template_ruimte')
  })
  .getStore()

vastgoed.mutations.RESET_VASTGOED_STATE = (state) => {
  const initial = initialState()
  for (const key in initial) {
    if (Object.prototype.hasOwnProperty.call(initial, key)) {
      state[key] = initial[key]
    }
  }
}

export default vastgoed
